var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 567,
    viewBox: "0 0 476 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M402.408 689.2H5.10825C-50.3917 689.2 -85.5918 625.2 -58.8918 572.9L22.2082 414.4C35.0082 389.3 59.5082 373.8 86.2082 373.8H312.208C337.608 373.8 361.208 388 374.508 411.3L464.708 569.8C494.408 622 459.408 689.2 402.408 689.2Z",
    fill: "#6786BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M203.708 293.2C284.673 293.2 350.308 227.565 350.308 146.6C350.308 65.6351 284.673 0 203.708 0C122.743 0 57.1082 65.6351 57.1082 146.6C57.1082 227.565 122.743 293.2 203.708 293.2Z",
    fill: "#6786BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconuser);
export default __webpack_public_path__ + "static/media/iconuser.ce488a63ed6a478e58bb4160ede29521.svg";
export { ForwardRef as ReactComponent };